import dxForm from 'devextreme/ui/form';
import { forEach } from 'lodash';

export const getItemOptions = (form: dxForm, id: string) => {
  return form.itemOption(id) || form.itemOption(`.${id}`);
};

export const setItemOptions = (form: dxForm, id: string, option: string, value: any) => {
  form.itemOption(id)
    ? form.itemOption(id, option, value)
    : form.itemOption(`.${id}`, option, value);
};

export const setEditorOptions = (form: dxForm, id: string, editorOptions: any) => {
  if (!form || !id || !editorOptions) return;

  const itemOptions = getItemOptions(form, id) || {};
  forEach(editorOptions, (v, k) => {
    if (itemOptions?.editorOptions?.[k] !== v) {
      setItemOptions(form, id, 'editorOptions', {
        ...itemOptions.editorOptions,
        [k]: v,
      });
    }
  });
};
